/**
 * Inhaber 03.10.2026: erst bezahlen, dann einrichten. Der Schnellstart merkt sich, dass nach dem Abschluss (Rückkehr von
 * Stripe oder PayPal) die Einrichtung folgt; das Portal löst die Marke einmal ein und führt zum ersten offenen Schritt.
 * Eigene kleine Datei, damit der Agenturrahmen die Einrichtungsseite nicht mitladen muss.
 */
const KEY = "tk-einrichtung-nach-zahlung";

export function merkeEinrichtungNachZahlung(on: boolean) {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    /* ohne Speicher: nach der Zahlung geht es zur Übersicht, die Einrichtung bleibt über die Hinweise erreichbar */
  }
}

/** Liefert einmalig true, wenn nach der Zahlung die Einrichtung folgen soll */
export function nimmEinrichtungNachZahlung(): boolean {
  try {
    if (localStorage.getItem(KEY) !== "1") return false;
    localStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
